import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  Stepper,
  Step,
  StepLabel,
  Select,
  MenuItem,
  FormControl,
  TextareaAutosize,
  IconButton,
  StepConnector,
  stepConnectorClasses,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const Initiation = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f8f9fa', p: 3 }}>
      {/* Stepper Outside the Box */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          mb: 2,
          bgcolor: '#fff',
          p: 2,
          borderRadius: 2,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <Box>
          <Stepper
            activeStep={1}
            sx={{ width: 200 }}
            connector={
              <StepConnector
                sx={{
                  [`& .${stepConnectorClasses.line}`]: {
                    borderColor: '#90caf9',
                    borderTopWidth: 2,
                    borderRadius: 1,
                  },
                }}
              />
            }
          >
            <Step completed>
              <StepLabel
                StepIconComponent={() => (
                  <Box
                    sx={{
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      border: '2px solid #90caf9',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#90caf9',
                      fontSize: 12,
                      fontWeight: 500,
                    }}
                  >
                    L
                  </Box>
                )}
              >
                <Typography variant="caption" sx={{ fontSize: 11, color: '#000000' }}>
                  Collection Tier
                </Typography>
              </StepLabel>
            </Step>
            <Step>
              <StepLabel
                StepIconComponent={() => (
                  <Box
                    sx={{
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      border: '2px solid #90caf9',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#90caf9',
                      fontSize: 12,
                      fontWeight: 500,
                    }}
                  >
                    L
                  </Box>
                )}
              >
                <Typography variant="caption" sx={{ fontSize: 11, color: '#000000' }}>
                  Initiation
                </Typography>
              </StepLabel>
            </Step>
          </Stepper>
        </Box>
        <IconButton>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Main Content with Heading Inside */}
      <Box sx={{ bgcolor: '#fff', p: 3, borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: '#000000', mb: 2 }}>
          Template Production
        </Typography>

        {/* Template Selection */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 500, color: '#000000', mb: 1 }}>
            Template
          </Typography>
          <FormControl fullWidth>
            <Select
              defaultValue="Mailing Template 1"
              sx={{
                bgcolor: '#f5f5f5',
                borderRadius: 1,
                '.MuiSelect-select': { py: 1.5 },
              }}
            >
              <MenuItem value="Mailing Template 1">Mailing Template 1</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Vendor Selection */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 500, color: '#000000', mb: 1 }}>
            Vendor
          </Typography>
          <FormControl fullWidth>
            <Select
              defaultValue="Vendor 2"
              sx={{
                bgcolor: '#f5f5f5',
                borderRadius: 1,
                '.MuiSelect-select': { py: 1.5 },
              }}
            >
              <MenuItem value="Vendor 2">Vendor 2</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Amount Selection */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 500, color: '#000000', mb: 1 }}>
            Amount
          </Typography>
          <FormControl fullWidth>
            <Select
              defaultValue="19,000"
              sx={{
                bgcolor: '#f5f5f5',
                borderRadius: 1,
                '.MuiSelect-select': { py: 1.5 },
              }}
            >
              <MenuItem value="19,000">19,000</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Email Template */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 500, color: '#000000', mb: 1 }}>
            Email
          </Typography>
          <TextareaAutosize
            minRows={5}
            placeholder="EMAIL TEMPLATE POPULATES HERE & ABILITY TO EDIT"
            style={{
              width: '100%',
              padding: '10px',
              border: '1px dashed #4caf50',
              borderRadius: '4px',
              fontSize: '14px',
              color: '#000000',
              backgroundColor: '#f5f5f5',
              resize: 'vertical',
            }}
          />
        </Box>

        {/* Send Button */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            sx={{
              bgcolor: '#4caf50',
              color: 'white',
              px: 4,
              py: 1,
              fontSize: 14,
              fontWeight: 600,
              borderRadius: 25,
              textTransform: 'none',
              boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)',
              '&:hover': {
                bgcolor: '#45a049',
                boxShadow: '0 6px 16px rgba(76, 175, 80, 0.4)',
              },
            }}
          >
            Send
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Initiation;